import BitmapText from 'core/display/simple/BitmapText'
import TextCreate from 'core/display/simple/Text'

export default class BigWinCounter {
  constructor(data) {
    return game.bigwin.counter = data.fontBitmap ? new BitmapText(data) : new TextCreate(data)
  }
}
